var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8878 12.1782C35.9197 12.4737 35.9916 12.7692 35.9916 13.0647C35.9996 18.0718 35.9996 23.0789 35.9916 28.086C35.9916 29.4835 35.217 30.2501 33.8115 30.2581C26.241 30.2581 18.6704 30.2581 11.0999 30.2581C9.70236 30.2581 8.93572 29.4755 8.92773 28.086C8.92773 25.6024 8.92773 23.1188 8.92773 20.6352C8.92773 20.5074 8.92773 20.3797 8.92773 20.2838C9.75027 20.3078 10.5329 20.3717 11.3075 20.3557C12.7529 20.3238 14.1025 19.9085 15.3563 19.1898C15.6039 19.054 15.7316 19.07 15.9313 19.2696C17.76 21.1223 19.6048 22.9591 21.4495 24.7958C22.0644 25.4107 22.5435 25.4027 23.1584 24.7958C27.2631 20.6911 31.3678 16.5864 35.4646 12.4817C35.5764 12.3699 35.6482 12.2262 35.7361 12.0984C35.792 12.1223 35.8399 12.1463 35.8878 12.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9024 9.46319C18.8865 14.7178 14.662 18.9104 9.40732 18.8944C4.20058 18.8864 -0.0159264 14.63 4.52245e-05 9.40729C0.0160168 4.19256 4.25648 -0.00797444 9.48718 1.13677e-05C14.7099 0.00799717 18.9184 4.24047 18.9024 9.46319ZM16.3071 9.47118C16.323 5.70188 13.2884 2.64331 9.49516 2.61137C5.74184 2.57943 2.63536 5.62202 2.6114 9.35139C2.58745 13.2085 5.59809 16.2751 9.41531 16.2911C13.2245 16.307 16.2911 13.2644 16.3071 9.47118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.033 22.6078C20.4678 21.0506 18.8067 19.3975 17.1377 17.7285C19.1661 15.8758 20.2282 13.5679 20.3081 10.7888C24.8759 10.7888 29.4278 10.7888 33.86 10.7888C29.9629 14.6939 25.994 18.6548 22.033 22.6078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6017 6.38062C13.0569 6.85178 13.4242 7.24308 13.7676 7.60244C12.0826 9.28745 10.3577 11.0124 8.67265 12.7054C7.69039 11.7231 6.65224 10.685 5.62207 9.65479C5.97345 9.31141 6.37274 8.92809 6.78001 8.53678C7.36298 9.11975 7.99385 9.75861 8.62473 10.3895C9.96635 9.0319 11.276 7.72223 12.6017 6.38062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 30.2582,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerified);
export default __webpack_public_path__ + "static/media/email_verified.2980426c47877c892a7b0b0f4e5f9d82.svg";
export { ForwardRef as ReactComponent };